module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-latin-ext-300-normal.woff2?dc7dcec8e3f654e0ed63f83e580d9c05";